(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sr-premium-finish"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sr-premium-finish')) {
    customElements.define('sr-premium-finish', class extends HTMLElement {
      connectedCallback() {
        this.main = this.closest('main');
        if (!this.main || this.dataset.motion !== 'true' || window.Shopify?.designMode) return;
        this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
        this.desktopQuery = matchMedia('(min-width: 990px) and (hover: hover)');
        this.restart = () => { this.stop(); this.start(); };
        this.motionQuery.addEventListener('change', this.restart);
        this.desktopQuery.addEventListener('change', this.restart);
        this.start();
      }

      start() {
        if (this.motionQuery.matches || navigator.connection?.saveData || !('IntersectionObserver' in window)) return;
        this.animations = new Set();
        this.activeImages = new Set();
        this.zoomImages = Array.from(this.main.querySelectorAll('.sr-home-hero__media img, .sr-home-cockpit__media img, .sr-proof__image img, .sr-engineered__image, .cevart-lux__craft > img, .sr-process__hero-image, .sr-accessories-hero__media img, .sr-vault-story__media img'));
        this.onFrame = () => {
          this.frame = 0;
          if (document.hidden || !this.desktopQuery.matches) return;
          const viewport = window.innerHeight;
          const updates = Array.from(this.activeImages).map(img => {
            const rect = img.parentElement.getBoundingClientRect();
            const progress = Math.max(0, Math.min(1, (viewport - rect.top) / (viewport + rect.height)));
            return [img, 1.035 - progress * .035];
          });
          updates.forEach(([img, scale]) => { img.style.transform = `scale(${scale.toFixed(4)})`; });
        };
        this.schedule = () => {
          if (!this.frame && !document.hidden && this.activeImages.size) this.frame = requestAnimationFrame(this.onFrame);
        };
        this.imageObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.activeImages.add(entry.target);
              entry.target.style.willChange = 'transform';
            } else {
              this.activeImages.delete(entry.target);
              entry.target.style.removeProperty('will-change');
            }
          });
          this.schedule();
        }, { rootMargin: '120px 0px' });
        if (this.desktopQuery.matches) {
          this.zoomImages.forEach(img => { img.classList.add('sr-zoom-image'); this.imageObserver.observe(img); });
          window.addEventListener('scroll', this.schedule, { passive: true });
          window.addEventListener('resize', this.schedule, { passive: true });
          document.addEventListener('visibilitychange', this.schedule);
        }
        this.revealObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.revealObserver.unobserve(entry.target);
            if (!entry.target.animate) return;
            const isImage = entry.target.tagName === 'IMG';
            const frames = isImage ? [
              { transform: 'scale(1.025)' },
              { transform: 'scale(1)' }
            ] : [
              { opacity: .4, transform: 'translateY(16px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ];
            const animation = entry.target.animate(frames, { duration: isImage ? 1600 : 850, easing: 'cubic-bezier(.22,.68,.22,1)', fill: 'none' });
            this.animations.add(animation);
            animation.onfinish = () => this.animations.delete(animation);
          });
        }, { threshold: .08, rootMargin: '0px 0px -35px 0px' });
        if (!this.desktopQuery.matches) {
          this.zoomImages.forEach(img => {
            if (img.getBoundingClientRect().top > window.innerHeight) this.revealObserver.observe(img);
          });
        }
        this.main.querySelectorAll('.sr-shop-collection__header, .sr-home-intro, .sr-home-cockpit__copy, .sr-cevart-home__copy, .sr-proof__copy, .sr-accessories-home__copy, .sr-engineered__content, .sr-home-close h2, .sr-center, .sr-values, .sr-process__header, .sr-process__card-copy, .cevart-lux__statement-grid, .cevart-lux__construction-copy, .cevart-lux__ar-copy, .cevart-lux__mission-heading, .sr-accessories-intro, .sr-vault-story__copy, .sr-benefits, .sr-accessories-close h2').forEach(element => {
          if (element.getBoundingClientRect().top > window.innerHeight) this.revealObserver.observe(element);
        });
      }

      stop() {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.imageObserver?.disconnect();
        this.revealObserver?.disconnect();
        this.animations?.forEach(animation => animation.cancel());
        this.animations?.clear();
        this.activeImages?.clear();
        this.zoomImages?.forEach(img => {
          img.style.removeProperty('transform');
          img.style.removeProperty('will-change');
          img.classList.remove('sr-zoom-image');
        });
        if (this.schedule) {
          window.removeEventListener('scroll', this.schedule);
          window.removeEventListener('resize', this.schedule);
          document.removeEventListener('visibilitychange', this.schedule);
        }
      }

      disconnectedCallback() {
        this.stop();
        this.motionQuery?.removeEventListener('change', this.restart);
        this.desktopQuery?.removeEventListener('change', this.restart);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sr-premium-home"] && !Shopify.designMode) return;
  try {
    
function initSRCardVideos(root) {
  const videos = root.querySelectorAll('.sr-card-video:not([data-sr-initialized])');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const video = entry.target;
      if (entry.isIntersecting && !reducedMotion.matches) {
        video.muted = true;
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.5 });
  videos.forEach(video => {
    video.dataset.srInitialized = 'true';
    observer.observe(video);
  });
}
initSRCardVideos(document);
document.addEventListener('shopify:section:load', event => initSRCardVideos(event.target));

  } catch(e) { console.error(e); }
})();
})();
